<template>
  <div id="app" class="appwrap">
    <router-view />
    <div class="nav-box">
      <div>
        <a :href="'tel:' + config.phone.configValue" :title="config.phone.configValue">
        <i class="el-icon-mobile"></i>
        <span class="title">手机热线</span>
        </a>
      </div>
      <div>
        <a :href="'tel:' + config.tel.configValue" :title="config.tel.configValue">
        <i class="el-icon-phone-outline"></i>
        <span class="title">服务热线</span>
        </a>
      </div>
      <div @click="handleOpenQr(config.weChat.configValue)">
        <i class="el-icon-star-off"></i>
        <span class="title">微信公众号</span>
      </div>
    </div>
    <div class="tabBar">
      <ul>
        <li v-for="(item, index) in tabBarList" :key="item.icon">
          <router-link :to="item.url">
            <i :class="item.icon"></i>
            <span>{{ item.label }}</span>
          </router-link>
        </li>
        <li>
          <a :href="'tel:' + config.tel.configValue">
            <i class="el-icon-phone"></i>
            <span>咨询</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {getConfigList} from '@/API/home'
import {mapGetters} from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      tabBarList: [
        { label: '首页', url: '/', icon: 'el-icon-s-home' },
        { label: '方案', url: '/programme', icon: 'el-icon-s-help' },
        { label: '案例', url: '/case', icon: 'el-icon-s-grid' }
      ],
    }

  },
  computed:{
    ...mapGetters(['config'])
  },
  methods: {
    handleOpenQr(url) {
      const h = this.$createElement;
      this.$msgbox({
        title:' ',
        customClass:"qr_weChat",
        showClose:true,
        showConfirmButton:false,
        message: h('img', {attrs:{src: url}, style: {margin:'auto', width: '300px',  }}),
      }).then(action => {

      }).catch(err => {});
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  padding: 0;
  margin: 0;
  height: 100%;
}

a {
  text-decoration: none;
  color: #000;
}

html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
}

.qr_weChat{
  .el-message-box__content {
    .el-message-box__message{
      text-align: center;
    }
  }
}

.details-box, .content{
  img{
    max-width: 100%;
  }
}


</style>
<style lang="scss" scoped>
$col: #14c187;

.nav-box {
  position: fixed;
  top: 50%;
  right: 30px;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 999;

  div {
    list-style: none;
    width: 70px;
    height: 70px;
    background-color: $col;
    margin-top: 4px;
    color: #eee;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    transition: all ease 0.5s;
    position: relative;
    cursor: pointer;
    a{
      color: #fff;
    }
    &:hover {
      width: 170px;
      color: #fff;

      .title {
        opacity: 1;
        position: relative
      }
    }

    .title {
      opacity: 0;
      position: absolute;
      right: 0;
      font-size: 18px;
      margin-left: 10px;

    }
  }
}

.tabBar {
  position: sticky;
  bottom: 0;
  z-index: 99;
  display: none;

  ul {
    padding: 0;
    margin: 0;
    display: flex;
    background-color: $col;

    li,
    li>a {
      min-width: 0;
      flex: 1;
      width: 100%;
      list-style: none;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 5px 0;
      color: #fff;

      &:active {
        opacity: 0.5;
      }

      i {
        font-size: 20px;
      }

      span {
        margin-top: 4px;
      }

    }
  }
}

@media (max-width:500px) {
  .nav-box {
    display: none;
  }

  .tabBar {
    display: block;
  }
}
</style>
